/**
 * change the state of sitecore tracking depending on the consents state.
 */
    function ApplyScAnalyticsConsent(){
        if (typeof window.OnetrustActiveGroups !== "string" || OnetrustActiveGroups === "0") 
        {
            return;
        }

        //C0004 - targeting, C0002 - performance
        const hasOneTrustConsent = OnetrustActiveGroups.includes("C0002");
        const hasScConsent = localStorage.getItem("sc-consent-synced")  === "true";
        if (hasOneTrustConsent === hasScConsent){
            return;
        }

        const pageId = document.querySelector('meta[name="sitecore-page-id"]')?.content;
        const url = hasOneTrustConsent ? "/api/sitecore/consent/give?sc_itemid="+pageId : "/api/sitecore/consent/revoke";
        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({})
        }).then(response => {
            if (response.ok) {
                localStorage.setItem("sc-consent-synced", hasOneTrustConsent);
            }
        });
    }

    window.addEventListener("OneTrustGroupsUpdated", function () {
        ApplyScAnalyticsConsent();
    });
